import { ModalPopup } from '@summer/ui-components';

import Track from 'components/hoc/Track';

const TrackedModalPopup = Track(ModalPopup);
export default TrackedModalPopup;
